export default __webpack_public_path__ + "static/instant-push-m-1ccd0ff2526c34959777f7942c5e4b61.webp";